export default "__VITE_ASSET__BzXaKWI$__"